import React, { lazy, Suspense } from 'react';
import ProtectedRoute from '../../shared/components/ProtectedRoute';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import ErrorPage from '../../error-page';

// Lazy load navigation components
const Navigation = lazy(() => import('../../routes/navigation/index'));

/**
 * Navigation feature routes with lazy loading
 */
export const navigationRoutes = [
  {
    path: '/navigation/:poolCode',
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingSpinner message="Loading navigation..." />}>
          <Navigation />
        </Suspense>
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
  },
];

export default navigationRoutes;

